import React from "react";

const LoadingState: React.FC<{
  onCancel: () => void;
}> = ({ onCancel }) => (
  <div className="text-center py-12">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
    <h3 className="text-xl font-medium mb-2">Analyzing Video</h3>
    <p className="text-gray-600 mb-6">This may take a few moments...</p>
    <button
      onClick={onCancel}
      className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
    >
      Cancel Analysis
    </button>
  </div>
);

export default LoadingState;